export default __webpack_public_path__ + "static/illustration-2-9ff42ee4ac14faea4583b3deb0657b47.svg";